import type React from 'react';

import type { EventMatchingDescriptorDescriptorType } from '@vlabs/api/luna-api/model/EventMatchingDescriptorDescriptorType';
import type { FaceId } from '@vlabs/api/luna-api/model/FaceId';
import type { Similarity } from '@vlabs/api/luna-api/model/Similarity';

import { EventMatchCardPoint3 } from './cards/EventMatchCard.point3';
import { FaceMatchCardPoint3 } from './cards/FaceMatchCard.point3';
import { PersonMatchCard } from './cards/PersonMatchCard';

type EventCardPoint3Props =
  | {
    type?: 'event';
    eventId: string;
    matcherType?: EventMatchingDescriptorDescriptorType;
    similarity?: Similarity;
  }
  | {
    type: 'face';
    faceId: FaceId;
    similarity?: Similarity;
  }
  | {
    type: 'person';
    externalId: string;
    similarity?: Similarity;
  };

function EventCardPoint3(props: EventCardPoint3Props): React.JSX.Element | null {
  if ('faceId' in props) {
    const { faceId, similarity } = props;
    return (
      <FaceMatchCardPoint3
        faceId={faceId}
        similarity={similarity}
      />
    );
  }

  if ('externalId' in props) {
    const { externalId, similarity } = props;
    return (
      <PersonMatchCard
        externalId={externalId}
        similarity={similarity}
      />
    );
  }

  if ('eventId' in props) {
    const { eventId, matcherType = 'face', similarity } = props;
    return (
      <EventMatchCardPoint3
        eventId={eventId}
        matcherType={matcherType}
        similarity={similarity}
      />
    );
  }

  return null;
}

export { EventCardPoint3 };
